export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-5-97adca6d23b3d8947bb58b2e814dd3e9.png";